import clsx from 'clsx';
import React, { forwardRef, useState } from 'react';
import { connect } from 'react-redux';
import { NavLink as RouterLink, useHistory } from 'react-router-dom';
//MUI
import Badge from '@mui/material/Badge';
import TextField from '@mui/material/TextField';
import { makeStyles } from 'tss-react/mui';
//ICONS
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/NotificationsOutlined';
import InputIcon from '@mui/icons-material/Input';
//DS
import useDSThemeCtx from 'src/components/DSThemeCtx';
import { modulos } from 'src/config';
import { baseName } from 'src/config/keys';
import { SCRN_NOT_FOUND } from 'src/constants/screens';
import { useLogOut } from 'src/hooks';
import { transformacion } from 'lib.common';
import { Copyright, MenuModulos, Perfil, SidebarMenu, Topbar, hooks } from 'lib.front';
import { loadingModal, openMsg } from 'src/redux-app';
import { Box, styled, Typography } from '@mui/material';

const logoUri = `${baseName}/images/logos/logo_dscont_whiteH50.png`;
const useStyles = makeStyles()(theme => ({
   signOutButton: {
      marginLeft: theme.spacing(1)
   },
   active: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      '& $icon': {
         color: theme.palette.primary.main
      }
   },
   copyright: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
   },
   root: {
      paddingTop: 56,
      height: '100%',
      [theme.breakpoints.up('sm')]: {
         paddingTop: 64
      }
   },
   shiftContent: {
      paddingLeft: 300
   },
   closeIsDesktop: {
      paddingLeft: 80
   },
   content: {
      height: 'calc(100% - 45px)',
      width: '100%',
      flexGrow: 1,
      overflow: 'auto'
   },
   flexGrow: {
      flexGrow: 1
   },
   listaMultiNivelCustom: {
      '& .MuiListItem-root': {
         borderRadius: '10px',
         paddingTop: '5px',
         paddingBottom: '5px',
         paddingRight: '5px',
         width: '100%'
      },
      '& .MuiButtonBase-root': {
         borderRadius: '10px',
         paddingTop: '5px',
         paddingBottom: '5px',
         width: '100%'
      },
      '& .MuiList-root': {
         width: '100%'
      }
   },
   scrollContainer: {
      overflow: 'auto',
      maxHeight: '64vh',
      [theme.breakpoints.down('xl')]: {
         maxHeight: '53vh'
      },
      [theme.breakpoints.down('lg')]: {
         maxHeight: '42vh'
      }
   },
   sideBarMenu: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      padding: '1rem'
   },
   marginTop64: {
      marginTop: '64px'
   }
}));

const CustomRouterLink = forwardRef((props, ref) => {
   const { classes } = useStyles();
   const { itemprops, to, ...others } = props;
   if (to || (itemprops && itemprops.to)) {
      const refLink = to || itemprops.to;
      return (
         <div ref={ref} style={{ flexGrow: 1 }}>
            <RouterLink activeClassName={classes.active} {...others} to={refLink} />
         </div>
      );
   } else {
      return <button {...props} />;
   }
});

function Main({ children, usuario, accesos }) {
   const { classes } = useStyles();
   const history = useHistory();
   const { isDesktop } = useDSThemeCtx();
   // CONTROL DE VISIBILIDAD DEL MENU
   const {
      openSidebar,
      toggleSideBarOpen,
      handleSidebarOpen,
      handleSidebarClose
   } = hooks.useOpenSidebar(isDesktop);

   //TOPBAR
   const logOut = useLogOut();
   const [notifications] = useState([]);
   const [encontrado, setEncontrado] = useState({ value: null, input: '' });
   function handleEncontradoInput(e, newValue) {
      setEncontrado({ ...encontrado, input: newValue });
   }
   function handleEncontradoValue(e, newValue) {
      if (newValue && newValue.to) {
         history.push(newValue.to);
         setEncontrado({ value: null, input: '' });
      }
   }
   function handleItemOnClick(item) {
      if (item.to) {
         history.push(item.to);
      }
   }
   function handleClickDerecho(e) {
      e.preventDefault();
   }
   return (
      <Box
         onContextMenu={handleClickDerecho}
         className={clsx(classes.root, {
            [classes.shiftContent]: isDesktop && openSidebar,
            [classes.closeIsDesktop]: isDesktop && !openSidebar
         })}
      >
         <Topbar color="primary">
            <IconButton color="inherit" onClick={toggleSideBarOpen} size="large">
               <MenuIcon />
            </IconButton>
            <RouterLink to="/">
               <img alt="Logo" src={logoUri} />
            </RouterLink>
            {/* Nombre app */}
            <Box sx={{ flexGrow: 1 }}>
               <Typography align='center' color='white' fontSize={20} sx={{mb:0, mr: { xs:'59px', lg:0}}}>
                  Sistema de Monitoreo
               </Typography>
            </Box>
            {/* BOTONES BARRA SUPERIOR */}
            <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
               <IconButton color="inherit" size="large">
                  <Badge badgeContent={notifications.length} color="primary" variant="dot">
                     <NotificationsIcon fontSize="large" />
                  </Badge>
               </IconButton>
            </Box>
            <IconButton className={classes.signOutButton} color="inherit" onClick={logOut}>
               <InputIcon />
            </IconButton>
         </Topbar>
         <SidebarMenu
            onMouseEnter={handleSidebarOpen}
            onMouseLeave={handleSidebarClose}
            onClose={handleSidebarClose}
            open={openSidebar}
            variant={isDesktop ? 'permanent' : 'temporary'}
            anchor="left"
         >
            <Perfil
               usuario={usuario}
               mapaUsuario={{
                  avatarSrc: 'avatar',
                  nombre: 'nombre',
                  apellido: 'apPaterno',
                  titulo: 'especialidad'
               }}
               onlyAvatar={!openSidebar}
            />
            <MenuModulos
               dividerProps={{
                  margin: '16px 0px',
                  overflow: 'hidden'
               }}
               modulos={modulos}
               mapaModulo={{
                  titulo: 'title',
                  icono: 'icon',
                  nodos: 'submenu',
                  valorIgnorar: 'to'
               }}
               buscadorProps={{
                  valorIgnorar: SCRN_NOT_FOUND,
                  soloHojas: false,
                  value: encontrado.value,
                  onChange: handleEncontradoValue,
                  inputValue: encontrado.input,
                  onInputChange: handleEncontradoInput,
                  clearOnBlur: true,
                  clearOnEscape: true,
                  selectOnFocus: true
               }}
               listaMultiNivelProps={{
                  contraerTodos: !openSidebar,
                  itemComponent: CustomRouterLink,
                  onItemClick: handleItemOnClick
               }}
               incluirBuscador={openSidebar}
            />
         </SidebarMenu>
         <Box component="main" className={classes.content}>
            {children}
         </Box>
         <Copyright
            className={classes.copyright}
            entidad="Data Service"
            urlEntidad="https://www.dscont.pe/"
         />
      </Box>
   );
}

function stateSelector(state) {
   return {
      usuario: state.auth.usuario,
      accesos: state.auth.accesos
   };
}
function mapDispatchToProps(dispatch) {
   return {
      callbackLoading: loading => {
         dispatch(loadingModal(loading));
      },
      callbackError: msg => {
         dispatch(openMsg(msg.toString()));
      }
   };
}

export default connect(stateSelector, mapDispatchToProps)(Main);
